import * as React from 'react';

import { ScaleTicketTab } from '~/modules/trade/types/scaleTickets';

type KeyboardShortcutsConfig = {
  onBack: () => void;
  onAddMaterial?: () => void;
  onSetTab: (tab: ScaleTicketTab) => void;
  onTakeWeight?: () => void;
  onCompleteInventory?: () => void;
  enabled?: boolean;
};

const isInputElement = (element: Element | null): boolean => {
  if (!element) return false;
  const tagName = element.tagName.toLowerCase();
  return (
    tagName === 'input' ||
    tagName === 'textarea' ||
    tagName === 'select' ||
    element.getAttribute('contenteditable') === 'true'
  );
};

export const useTicketKeyboardShortcuts = ({
  onBack,
  onAddMaterial,
  onSetTab,
  onTakeWeight,
  onCompleteInventory,
  enabled = true,
}: KeyboardShortcutsConfig) => {
  React.useEffect(() => {
    if (!enabled) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (isInputElement(document.activeElement)) {
        if (event.key === 'Escape' && event.metaKey) {
          event.preventDefault();
          onBack();
        }
        return;
      }

      if (event.metaKey) {
        switch (event.key) {
          case 'Escape':
            event.preventDefault();
            onBack();
            break;
          case '1':
            event.preventDefault();
            onAddMaterial?.();
            break;
          case '3':
            event.preventDefault();
            onSetTab('materials');
            break;
          case '4':
            event.preventDefault();
            onSetTab('notes');
            break;
          case '5':
            event.preventDefault();
            onSetTab('photos');
            break;
          case '6':
            event.preventDefault();
            onSetTab('files');
            break;
          case '7':
            event.preventDefault();
            onSetTab('supplierInfo');
            break;
          case '8':
            event.preventDefault();
            onSetTab('documents');
            break;
          case '9':
            event.preventDefault();
            onSetTab('history');
            break;
        }
      }

      if (event.altKey && (event.key === 'f' || event.code === 'KeyF')) {
        event.preventDefault();
        onCompleteInventory?.();
      }

      if (event.key === ' ' && onTakeWeight) {
        event.preventDefault();
        onTakeWeight();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [
    enabled,
    onBack,
    onAddMaterial,
    onSetTab,
    onTakeWeight,
    onCompleteInventory,
  ]);
};
